<template>
  <v-window>
    <v-content :class="{'landscape': isLandscape(), 'portrait': !isLandscape(), 'large': isLarge(),
                      'xs': $vuetify.breakpoint.xs, 'sm': $vuetify.breakpoint.sm,
                      'md': $vuetify.breakpoint.md, 'lg': $vuetify.breakpoint.lg,
                      'xl': $vuetify.breakpoint.xl}">

      <v-toolbar class="primary"
                 dark
                 fixed
                 dense
                 app
                 :height="getToolbarHeight"
                 style="z-index:10">

        <div class="hidden-md-and-up"
             style="width:100%">
          <v-layout row
                    wrap>
            <v-flex xs12>
              <v-btn color="primary darken-1"
                     :to="goBack"
                     absolute
                     icon>
                <v-icon>arrow_back</v-icon>
              </v-btn>

              <router-link to="/">
                <v-img src="/image/logo_bg_white.png"
                       width="200px"
                       height="40px"
                       class="mx-auto">
                </v-img>
              </router-link>
            </v-flex>
          </v-layout>

          <v-toolbar-items class="menuOptions mt-3 justify-center ">
            <v-btn flat
                   small
                   to="/login"
                   class="bold text-shadow">{{ $t('site.menu.login') }}</v-btn>
            <v-btn v-if="!isChile"
                   flat
                   small
                   to="/register"
                   class="bold text-shadow">{{ $t('site.menu.signup') }}</v-btn>
          </v-toolbar-items>
        </div>

        <v-layout class="hidden-sm-and-down wrap"
                  row>
          <v-btn color="primary"
                 :to="goBack"
                 icon
                 v-if="isDetailPage">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-btn icon
                 disabled
                 v-else>
            <v-icon></v-icon>
          </v-btn>

          <v-toolbar-title class="ml-0 pt-1">
            <router-link to="/">
              <v-img src="/image/logo_bg_white.png"
                     width="200px"
                     height="40px">
              </v-img>
            </router-link>
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-toolbar-items class="menuOptions align-center">
            <city-selector></city-selector>

            <change-language-dropdown onlyText
                                      class="px-2"
                                      color="white"></change-language-dropdown>

            <v-btn flat
                   to="/login"
                   class="bold text-shadow">{{ $t('site.menu.login') }}</v-btn>
            <v-btn v-if="!isChile"
                   flat
                   to="/register"
                   class="bold text-shadow">{{ $t('site.menu.signup') }}</v-btn>
          </v-toolbar-items>
        </v-layout>
      </v-toolbar>

      <router-view></router-view>

      <wsp-footer></wsp-footer>
    </v-content>
  </v-window>
</template>

<script>
import WspFooter from '@/components/commons/WspFooter';
import InstallApp from '@/components/commons/InstallApp';
import ChangeLanguageDropdown from '@/components/commons/ChangeLanguageDropdown';
import CitySelector from '@/components/public/CitySelector';
import store from '@/store';
import utilService from '@/services/utilService';

export default {
  name: 'PublicParkingLayout',
  components: {
    [WspFooter.name]: WspFooter,
    [InstallApp.name]: InstallApp,
    [ChangeLanguageDropdown.name]: ChangeLanguageDropdown,
    [CitySelector.name]: CitySelector
  },
  computed: {
    getToolbarHeight() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return '120px';
      } else {
        return null;
      }
    },
    goBack() {
      if (store.state.user) {
        return this.$i18n.t('urlUser')
      } else {
        return this.$i18n.t('urlParkingPage')
      }
    },
    isDetailPage() {
      return !(this.$route.name === 'Home')
    },
    // Chile: servicio cerrado, no se ofrece registro de nuevos usuarios.
    isChile() {
      return utilService.isChile();
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (store.state.isLogged && to.name !== 'Logout') {
        next(vm.$i18n.t('urlParkingDetail', { alias: vm.$route.params.alias }));
        return;
      }

      document.title = vm.$i18n.t(to.meta.i18nTitle);
    });
  },
  data() {
    return {};
  },
  created() {},
  destroyed() {},
  methods: {
    isLandscape() {
      return this.$vuetify.breakpoint.height < this.$vuetify.breakpoint.width;
    },

    isLarge() {
      return this.$vuetify.breakpoint.height > 650;
    }
  }
};
</script>

<style lang="scss">
@import '~@/assets/css/public.scss';
</style>
